export class User {
  constructor(
    public username: string,
    public id: string,
    private _token: string,
    private _tokenExpirationDate: Date,
    public isStaff: boolean = false,
    public isSuperuser: boolean = false,
    public groups: string[] = []
  ) {}

  get token() {
    if (!this._tokenExpirationDate || new Date() > this._tokenExpirationDate) {
      return null;
    }
    return this._token;
  }
}
